import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Quote } from 'lucide-react';
import { useSiteData } from '../lib/SiteDataContext';
import { resolveImage } from '../lib/api';

const PresidentMessage = () => {
  const { settings } = useSiteData();
  const p = settings?.president;
  const hs = settings?.home_sections || {};
  if (!p) return null;
  const photo = p.photo_url ? resolveImage(p.photo_url) : '';
  return (
    <section className="relative bg-gradient-to-b from-[#F6F2EA] to-[#FAF6EC] py-24">
      <div className="mx-auto max-w-[1280px] px-6">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-12">
          <div className="relative lg:col-span-5">
            <div className="relative">
              <div className="absolute -left-3 -top-3 h-24 w-24 border-l-2 border-t-2 border-[#C9A86A]" />
              <div className="absolute -bottom-3 -right-3 h-24 w-24 border-b-2 border-r-2 border-[#C9A86A]" />
              <div className="overflow-hidden rounded-md bg-white shadow-xl">
                {photo ? (
                  <img src={photo} alt={p.name} className="h-[520px] w-full object-cover" />
                ) : (
                  <div className="flex h-[520px] w-full items-center justify-center bg-[#F6F2EA] text-[#0B2545]/40">
                    <span className="text-[13px]">Photo not set</span>
                  </div>
                )}
                <div className="border-t-2 border-[#C9A86A] bg-white p-6">
                  <div className="font-serif text-xl font-bold text-[#0B2545]">{p.name}</div>
                  <div className="mt-1 text-[13px] text-[#0B2545]/65">{p.title}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-7">
            <div className="mb-3 inline-flex items-center gap-2 text-[12px] font-semibold uppercase tracking-[0.22em] text-[#C9A86A]">
              {hs.president_eyebrow || 'Message from the President'}
            </div>
            <h2 className="font-serif text-3xl font-bold leading-tight text-[#0B2545] md:text-[40px]">
              {p.headline}
            </h2>
            <div className="mt-5 h-[3px] w-16 bg-[#C9A86A]" />
            <div className="relative mt-7">
              <Quote size={42} className="absolute -left-1 -top-2 text-[#C9A86A]/40" />
              <div className="space-y-5 pl-12 text-[15px] leading-relaxed text-[#0B2545]/80">
                {(p.paragraphs || []).map((para, i) => <p key={i}>{para}</p>)}
              </div>
            </div>
            <Link
              to="/government/office-of-the-president"
              className="group mt-8 inline-flex items-center gap-2 rounded-md bg-[#0B2545] px-6 py-3 text-[14px] font-medium text-white shadow-md transition hover:bg-[#08203a]"
            >
              {hs.president_button_label || 'Read Full Message'}
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PresidentMessage;
